// extracted by mini-css-extract-plugin
export default {"icon":"AconexComponent_icon__G1liG","aconex":"AconexComponent_aconex__RXdno"};